import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { DefaultSelection } from 'src/app/models/default-selection.model';
import { DefaultSelectionState, DefaultSelectionStore } from './default.store';

@Injectable({ providedIn: 'root' })
export class DefaultSelectionQuery extends QueryEntity<DefaultSelectionState, DefaultSelection> {
  constructor(protected override store: DefaultSelectionStore) {
    super(store);
  }
}
